import { render } from "./VButton.vue?vue&type=template&id=0b3558b1&scoped=true"
import script from "./VButton.vue?vue&type=script&lang=js"
export * from "./VButton.vue?vue&type=script&lang=js"

import "./VButton.vue?vue&type=style&index=0&id=0b3558b1&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3558b1"]])

export default __exports__